/**
 * An notification type that can be shown to the user
 */
// eslint-disable-next-line import/prefer-default-export
export enum NotificationType {
  REMINDER_ALARM = 'REMINDER_ALARM',
  REVIEW_INTERACTION = 'REVIEW_INTERACTION',
  ADDED_INTERACTION_NOTE = 'ADDED_INTERACTION_NOTE',
  EDITED_INTERACTION_NOTE = 'EDITED_INTERACTION_NOTE',
}
